export default __webpack_public_path__ + "static/technology-page-hero-60c4bc8c7c954c7689def8c180f4a51a.svg";